import { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

//api
import { ProjectManagementService } from '../../../service/projectmanagement-service';
import { PromptService } from '../../../service/prompt-service';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';


const UpdateProjectPrompt = ({ projectId, project })=>{
const {
    
    handleSubmit,
    setValue,

  } = useForm();
  const [promptsData, setPromptsData] = useState({
    count: 0,
    next: null,
    previous: null,
    results: [],
  });
  const navigate = useNavigate()
  const [selectedSystemPrompt, setSelectedSystemPrompt] = useState(null);
  const [selectedDefaultPrompt, setSelectedDefaultPrompt] = useState(null);
  const [selectedSystemPromptContent, setSelectedSystemPromptContent] = useState('');
  const [selectedDefaultPromptContent, setSelectedDefaultPromptContent] = useState('');
  
  const toast = useRef(null);

  //chiamata GET per recuperare i prompt
    useEffect(() => {
      const fetchPrompts = () => {
        PromptService.getAllPrompts(
          (data) => {
            if (data && Array.isArray(data.results)) {
              setPromptsData(data);
            } else {
              const errorMessage =
                'La risposta non contiene un array valido di prompt.';
              console.error(errorMessage);
            }
          },
          (error) => {
            console.error('Errore durante il recupero dei prompt: ', error);
          }
        );
      };
      fetchPrompts();
    }, []);
  
    const systemPrompts = promptsData.results.filter(
      (prompt) => prompt.is_system
    );
    const defaultPrompts = promptsData.results.filter(
      (prompt) => prompt.is_default
    );

    //ripopola il form
  useEffect(() => {
    if (project) {
      setSelectedDefaultPrompt(project.user_prompt_details || null);
      setSelectedSystemPrompt(project.system_prompt_details || null);

      if(project.user_prompt_details){
        setSelectedDefaultPromptContent(project.user_prompt_details.content || '');
      } else {
        setSelectedDefaultPromptContent('')
      } 
      
      
      if (project.system_prompt_details){
        setSelectedSystemPromptContent(project.system_prompt_details.content || '');
      } else {
        setSelectedSystemPromptContent('')
      }
    }
  }, [project, setValue]);

  // aggiorna textarea del prompt di sistema
  useEffect(()=>{
    if(selectedSystemPrompt){
      setSelectedSystemPromptContent(selectedSystemPrompt.content);
    
    } else {
      setSelectedSystemPromptContent(''); //svuota se deselezionato
    }
  }, [selectedSystemPrompt])

  // aggiorna textarea del prompt di default
  useEffect(()=>{
    if(selectedDefaultPrompt){
      setSelectedDefaultPromptContent(selectedDefaultPrompt.content);
    } else {
      setSelectedDefaultPromptContent('') //svuota se deselezionato
    }
  }, [selectedDefaultPrompt])

  //chiamata PUT
  const onSubmit = (data) => {
    console.log(projectId);
    const payload = {
      id: projectId,
      name: project?.name, 
      notes: project?.notes,
      system_prompt: selectedSystemPrompt ? selectedSystemPrompt.id : null,
      user_prompt: selectedDefaultPrompt ? selectedDefaultPrompt.id : null,
    };
    ProjectManagementService.updateExistingProject(
      projectId,
      payload,
      (response) => {
        toast.current.show({
          severity: 'success',
          summary: 'Modifica',
          detail: 'Progetto modificato!',
        });
        navigate('/dashboard/projects')
      }
    );
  };
  return (
    <div style={{ width: '50%' }}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="projectManagement__FormContainer">
          <div>
            <div className="addProject__Dropdown">
              <label>Prompt di Sistema</label>
              <div className='projectManagement__PromptWrapper'>
                <Dropdown
                  value={selectedSystemPrompt}
                  onChange={(e) => setSelectedSystemPrompt(e.value)}
                  options={systemPrompts}
                  optionLabel="name"
                  placeholder="Seleziona un Prompt di Sistema"
                  className="w-full md:w-14rem projectManagement__Dropdown"
                />
                  {
                    selectedSystemPromptContent && (
                        <InputTextarea
                          id="projectManagement_Input"
                          value={selectedSystemPromptContent}
                          readOnly
                          rows={5}
                          cols={20}
                          className='projectManagement__PromptTextarea'
                        />
                    )
                  }
              </div>
            </div>
            <div className="addProject__Dropdown">
              <label>Prompt di Default</label>
              <div className='projectManagement__PromptWrapper'>
                <Dropdown
                value={selectedDefaultPrompt}
                onChange={(e) => setSelectedDefaultPrompt(e.value)}
                options={defaultPrompts}
                optionLabel="name"
                placeholder="Seleziona un Prompt di Default"
                className="w-full md:w-14rem projectManagement__Dropdown"
              />
              {
                selectedDefaultPromptContent && (
                  <InputTextarea
                    id="projectManagement_Input"
                    value={selectedDefaultPromptContent}
                    readOnly
                    rows={5}
                    cols={20}
                    className='projectManagement__PromptTextarea'
                />
                )
              }
              </div>
              
              
            </div>
          </div>
          <div className="projectManagement__SaveBtn">
            <div>
              <Toast ref={toast} />
            <Button>Salva</Button>
            </div>
            
          </div>
        </div>
      </form>
    </div>
  );
}

export default UpdateProjectPrompt